import axiosPost from "../axiosPost";

export const migraUsuarioPasoUpd = async (
    {
        migraUsuarioPasoId,
        migraUsuarioPasoSemaforo,
        migraUsuarioPasoIdentificacion = null,
        migraUsuarioPasoOrigenDestino = null,
    },
    credentials
) => {
    const body = {
        service: "MigraUsuarioPasoUpd",
        params: {
            migraUsuarioPasoId,
            migraUsuarioPasoSemaforo,
            migraUsuarioPasoIdentificacion,
            migraUsuarioPasoOrigenDestino,
        },
    };

    return await axiosPost(body, credentials);
};
